export default __webpack_public_path__ + "static/media/zukunf_lauft_background_l1.115eedee.jpg";